import React from 'react';
import { PropTypes as PT } from 'prop-types';
import MiniPlayerHeader from 'components/MiniPlayer/MiniPlayerHeader';
import MiniPlayerFooter from 'components/MiniPlayer/MiniPlayerFooter';
import { miniplayerMode } from 'constants/InCall/InCallVideo';
import 'styles/core.module.scss';
import classes from './MiniPlayer.module.scss';

class MiniPlayer extends React.Component {
  componentDidMount = async () => {
/*    this.addClassToElement('html', classes.miniPlayer);
    this.addClassToElement('body', classes.miniPlayer);
    const mountNode = document.getElementById('root');
    mountNode.classList.add(classes.miniPlayerRoot);*/
    await this.updateVideoElement();
    this.killElectronThrottling();
  };

/*  addClassToElement(tagName, className) {
    document.getElementsByTagName(tagName)[0].classList.add(className);
  }*/

  componentDidUpdate = async (prevProps) => {
    const newMode = this.props.miniplayerMode;
    const oldMode = prevProps.miniplayerMode;
    const newCamera = this.props.localVideoDeviceId;
    const oldCamera = prevProps.localVideoDeviceId;
    const newRemoteStream = this.props.remoteVideoStream;
    const oldRemoteStream = prevProps.remoteVideoStream;
    if (newMode !== oldMode ||
      (newMode === miniplayerMode.local && newCamera !== oldCamera) ||
      (newMode === miniplayerMode.remote && newRemoteStream !== oldRemoteStream)) {
      await this.updateVideoElement();
    }
  };

  updateVideoElement = async () => {
    // React doesn't treat srcObject as a prop
    this.videoElement.srcObject = this.props.miniplayerMode === miniplayerMode.remote ?
      this.props.remoteVideoStream :
      await this.createLocalStream();
  };

  createLocalStream = () => {
    const constraints = {
      audio: false,
      video: this.props.localVideoDeviceId ? { deviceId: this.props.localVideoDeviceId } : true
    };
    return navigator.mediaDevices.getUserMedia(constraints);
  };

  killElectronThrottling() {
    // HACK: Electron backgroundThrottling is not working
    // The workaround is to update the window 30 times/second
    // See https://github.com/electron/electron/issues/9567
    const throttleKiller = document.getElementById('throttleKiller');
    if(throttleKiller && this.props.isMiniPlayerOpen){
      setInterval(() => {
        throttleKiller.textContent = Date.now();
      }, 1000 / 30);
    }
  }

  render = () => {
    if (!this.props.isMiniPlayerOpen) return null;
    return(
      <>
        <div className={classes.miniPlayerRoot}>
          <MiniPlayerHeader onGoBackClick={this.props.onGoBackClick} title={this.props.title}/>
          <div className={classes.videoElementContainer}>
            <video
              className={this.props.miniplayerMode === miniplayerMode.local ? classes.localVideo : undefined}
          ref={(video) => { this.videoElement = video; }}
              autoPlay
              muted
              onDoubleClick={this.props.onSwitchViewClick}
            />
          </div>
          <MiniPlayerFooter
            onSwitchViewClick={this.props.onSwitchViewClick}
            isAudioEnabled={this.props.isAudioEnabled}
            isModerator={this.props.isModerator}
            onEndCallClick={this.props.onEndCallClick}
            onToggleAudioClick={this.props.onToggleAudioClick}
            startTime={this.props.startTime}
            isMutedByServer={this.props.isMutedByServer}
          />
        </div>
        <div id="throttleKiller" />
      </>
    )

  }
}

MiniPlayer.propTypes = {
  startTime: PT.number,
  isAudioEnabled: PT.bool,
  isModerator: PT.bool,
  isMutedByServer: PT.bool,
  miniplayerMode: PT.string,
  title: PT.string,
  onEndCallClick: PT.func,
  onGoBackClick: PT.func,
  onToggleAudioClick: PT.func,
  onSwitchViewClick: PT.func,
  remoteVideoStream: PT.object,
  localVideoDeviceId: PT.string,
  isMiniPlayerOpen: PT.bool
};

export default MiniPlayer;
